// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small[data-v-9f595718]{max-width:100%;margin:10px auto}", ""]);
// Exports
module.exports = exports;
